import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/footer";
import AboutUs from "../components/AboutUs";

const Aboutus = () => {
  return (
    <>
      {/* Helmet goes at the top of the page */}
      <Helmet>
        <title>About Us | Iklim Digitals</title>
        <meta
          name="description"
          content="Iklim Digitals empowers Ethiopian businesses with digital marketing, branding, advertising, and web development solutions."
        />
        <meta
          name="keywords"
          content="Ethiopia digital marketing, branding, advertising, web development, Iklim Digitals"
        />
      </Helmet>

     
      <Header />
      <AboutUs />
      <Footer />
    </>
  );
};

export default Aboutus;
